// ═══════════════════════════════════════════════════════════════════
//  composants/Panel.js
//  Panel
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

export function Panel({ title, action, children, style }) {
  return (
    <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 14, padding: 18, ...style }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
        <div style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase" }}>{title}</div>
        {action && <div style={{ marginLeft: "auto" }}>{action}</div>}
      </div>
      {children}
    </div>
  );
}
